import { SignUp } from "@clerk/clerk-react";
import { createFileRoute, Link, useLinkProps } from "@tanstack/react-router";
import { StartPageShell } from "~/components/app-shell/start-page-shell";
import { Card } from "~/components/ui/card";
import { isFeatureFlagEnabled } from "~/instrumentation/feature-flags";
import { Route as OnboardingRoute } from "~/routes/onboarding/route";

export const Route = createFileRoute("/(auth)/sign-up")({
  component: SignUpPage,
  head: () => ({
    meta: [{ title: "Sign Up" }],
  }),
});

function SignUpPage() {
  const { href: redirectUrl } = useLinkProps({
    to: OnboardingRoute.fullPath,
    search: { source: "sign-up" },
  });

  const searchParams = new URLSearchParams(window.location.search);
  const showSignUp =
    isFeatureFlagEnabled("sign_up") && searchParams.get("admin");

  return (
    <StartPageShell>
      <StartPageShell.MainContent>
        {showSignUp ? (
          <SignUp
            fallbackRedirectUrl={redirectUrl}
            forceRedirectUrl={redirectUrl}
          />
        ) : (
          <Card className="shadow-2xl shadow-black/15 p-4 w-full max-w-[446px] min-h-[200px] rounded-[12px] flex flex-col items-center justify-center">
            {/* @ts-expect-error - form-widget is a web component */}
            <form-widget ucid="jUeGCOuQyEKrHP4G9l4YrbCqo8g"></form-widget>

            <div className="text-sm text-muted-foreground w-full mx-3 px-4 text-center">
              <div className="border-b h-0 mb-3.5 w-full" />
              Already have an account?{" "}
              <Link to="/sign-in" className="text-foreground font-medium">
                Sign in
              </Link>
            </div>
          </Card>
        )}
      </StartPageShell.MainContent>
    </StartPageShell>
  );
}
